export const TOPIC_CHIPS = ['Cuenta', 'Datos personales', 'Entrenamientos', 'Soporte'];

export const HERO_PANEL_ITEMS = [
  {
    title: 'Verificación',
    description: 'Necesitamos tu correo para confirmar que eres titular de la cuenta.',
  },
  {
    title: 'Resultado',
    description: 'La cuenta se desactiva y se marca como eliminada.',
  },
  {
    title: 'Privacidad',
    description: 'privacy',
  },
];

export const SIDEBAR_ITEMS = [
  {
    title: 'Verificación',
    description: 'Necesitamos tu correo para confirmar que eres titular de la cuenta.',
  },
  {
    title: 'Resultado',
    description: 'La cuenta se desactiva y se marca como eliminada.',
  },
  {
    title: 'Privacidad',
    description: 'privacy',
  },
  {
    title: 'Soporte',
    description: 'Si no puedes acceder, usa el centro de ayuda.',
  },
];

export const PROCESS_STEPS = [
  'Ingresas el correo electrónico usado en el registro de la app.',
  'Sthenus envía un correo de confirmación al correo indicado.',
  'Al confirmar, la cuenta se desactiva y queda marcada como eliminada.',
  'Los datos relacionados se eliminan, anonimizan o conservan únicamente cuando exista una obligación aplicable.',
];

export const RETENTION_ITEMS = [
  {
    title: 'Entrenamientos y progreso',
    description:
      'pueden conservarse de forma anonimizada o agregada para estadísticas internas, o cuando formen parte de un historial sujeto a obligaciones legales.',
  },
  {
    title: 'Fotos y archivos de progreso',
    description:
      'pueden conservarse si forman parte de una operación que requiere trazabilidad legal u operativa.',
  },
  {
    title: 'Registros técnicos',
    description:
      'pueden conservarse temporalmente para seguridad, diagnóstico, prevención de fraude y continuidad del servicio.',
  },
];

export const AUTHORIZATION_TEXT =
  'Al enviar esta solicitud, se enviará un correo de confirmación al correo solicitado si autorizas la eliminación de tu cuenta Sthenus. Algunos registros de entrenamientos, progreso, facturación, auditoría o seguridad pueden conservarse durante el plazo requerido por ley o por obligaciones operativas.';

export const CONFIRM_LOADING_MESSAGE = 'Confirmando eliminación de tu cuenta...';

export const CONFIRM_SUCCESS_TITLE = 'Cuenta eliminada correctamente';

export const CONFIRM_SUCCESS_DESCRIPTION =
  'Tu cuenta y los datos personales asociados han sido eliminados. En unos segundos serás redirigido a la pantalla de inicio.';

export const CONFIRM_MISSING_CODE_MESSAGE =
  'El enlace no es válido porque falta el código de confirmación.';

export const CONFIRM_INVALID_CODE_MESSAGE =
  'Este enlace de confirmación no es válido o ha expirado. Solicita uno nuevo para continuar con la eliminación de tu cuenta.';

export const CONFIRM_ALREADY_DELETED_MESSAGE =
  'Esta cuenta ya fue eliminada anteriormente. No es necesario realizar ninguna acción adicional.';

export const CONFIRM_GENERIC_ERROR_MESSAGE =
  'No se pudo confirmar la eliminación de tu cuenta. Por favor, inténtalo de nuevo.';

export const CONFIRM_OFFLINE_ERROR_MESSAGE =
  'Sin conexión a internet. Verifica tu conexión e inténtalo de nuevo.';
